import React from 'react';
import { useRsi } from '../../hooks/useRsi';
import { Button, useBpDesignTheme, Dialog } from '@beeline.com/bp-design-system';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const SubmitDataAlert = ({ isOpen, onClose, onConfirm }: Props) => {
  const { allowInvalidSubmit, translations } = useRsi();
  const theme = useBpDesignTheme();
  return (
    <Dialog
      title={translations.alerts.submitIncomplete.headerTitle}
      subTitle={
        allowInvalidSubmit
          ? translations.alerts.submitIncomplete.bodyText
          : translations.alerts.submitIncomplete.bodyTextSubmitForbidden
      }
      open={isOpen}
      onClose={onClose}
      show={{
        cancelButton: true
      }}
      actions={
        allowInvalidSubmit
          ? [
              <Button
                onClick={onConfirm}
                style={{ marginLeft: theme.spacingSize.l }}
                color="primary"
                key="confirm"
                variant="contained"
              >
                {translations.alerts.submitIncomplete.finishButtonTitle}
              </Button>
            ]
          : undefined
      }
      id="rsi"
    />
  );
};
